import { Box } from "@mui/material";
import type { PimoReactComponent } from "@pimo/pimo-app-builder";
import { ComponentTitleCard } from "@pimo/pimo-components";
import {
  OverviewFilterData,
  OverviewFilterOptions,
  PropertyFilters,
} from "aint-types";

import {
  OverviewTitleCardSearchBarSlot,
  OverviewTitleCardSearchBarSlotProps,
} from "./overview-title-card-search-bar-slot.tsx";

export type OverviewTitleCardProps = {
  title?: string;
  filterOptions: OverviewFilterOptions;
  filterData: OverviewFilterData;
};

const handleFilterChange = (
  trigger: keyof PropertyFilters,
  filterData: OverviewFilterData,
  event: React.ChangeEvent<HTMLInputElement>,
  fireEvent?: (
    event: "filter:clear" | "filter:apply",
    payload?: OverviewFilterData
  ) => void
) => {
  if (!Array.isArray(filterData[trigger])) return;

  const filterArray = filterData[trigger];
  if (event.target.checked) {
    filterArray.push(event.target.name);
  } else {
    filterData[trigger] = filterArray.filter(
      (uncheckedValue) => uncheckedValue !== event.target.name
    ) as unknown as (typeof filterData)[typeof trigger];
  }

  fireEvent?.("filter:apply", filterData);
};

export const OverviewTitleCard: PimoReactComponent<
  OverviewTitleCardProps,
  "filter:clear" | "filter:apply",
  OverviewFilterData
> = ({ title, filterData, filterOptions, fireEvent, ...props }) => {
  return (
    <ComponentTitleCard
      title={title || "OE Overview"}
      endSlot={
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <OverviewTitleCardSearchBarSlot
            {...(props as OverviewTitleCardSearchBarSlotProps)}
            clearAllFilters={() => fireEvent?.("filter:clear")}
            filterData={filterData}
            filterOptions={filterOptions}
            handleFilterChange={(event, trigger) => {
              handleFilterChange(
                trigger as keyof PropertyFilters,
                filterData,
                event,
                fireEvent
              );
            }}
            handleSearchQueryChange={(value) => {
              filterData.searchQueryFilter = value;
              fireEvent?.("filter:apply", filterData);
            }}
          />
        </Box>
      }
    />
  );
};
